import AlertMessage from "@components/alert-message";
import Header from "@components/header-detail";
import Spacer from "@components/Spacer";
import { ActivityIndicator, Text, View } from "dripsy";
import * as React from "react";
import { Platform } from "react-native";

import { useIsBeheerder } from "./beheer-api";

// Uitleg die op elk beheerscherm terugkomt: wanneer klanten een nieuwe foto zien.
export const CACHE_NOTICE =
  "Een nieuwe foto staat direct in de webwinkel en in de nieuwste app. Oudere app-versies tonen hem binnen ongeveer een uur.";

export function BeheerHeader({ title }: { title: string }) {
  return Platform.OS !== "web" ? <Header title={title} /> : <View sx={{ height: 25 }} />;
}

// BeheerGuard toont de inhoud alleen aan beheerders. De server weigert de
// verzoeken van anderen sowieso (403); dit voorkomt alleen een leeg scherm.
export function BeheerGuard({ children }: { children: React.ReactNode }) {
  const { isBeheerder, isLoading } = useIsBeheerder();
  if (isLoading) {
    return (
      <View sx={{ padding: "$4", alignItems: "center" }}>
        <ActivityIndicator />
      </View>
    );
  }
  if (!isBeheerder) {
    return (
      <View sx={{ padding: "$3" }}>
        <AlertMessage isSuccess={false}>Je hebt geen toegang tot het fotobeheer.</AlertMessage>
      </View>
    );
  }
  return <>{children}</>;
}

export function Notice() {
  return (
    <View
      sx={{
        backgroundColor: "$secondaryBackgroundDarker",
        borderRadius: 8,
        padding: "$2",
      }}
    >
      <Text sx={{ fontSize: 14, color: "$text" }}>{CACHE_NOTICE}</Text>
    </View>
  );
}

export function SectionTitle({ children }: { children: string }) {
  return (
    <>
      <Spacer size="$3" />
      <Text sx={{ fontSize: 18, fontWeight: "600", color: "$text", marginBottom: "$1" }}>{children}</Text>
    </>
  );
}

export function Muted({ children }: { children: React.ReactNode }) {
  return <Text sx={{ fontSize: 14, color: "$textGrey" }}>{children}</Text>;
}
